<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <!-- <a-button class="form_btn" type="primary" size="mini" @click="handle('search')">{{ $t('base.search') }}</a-button>
                <a-button class="form_btn" type="outline" size="mini" @click="handle('reset')">{{ $t('base.reset') }}</a-button> -->

                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <div class="unoutboundCount">
            <a-button class="form_btn" type="primary" size="mini" v-permission="'setting.stock.exportExchange'" :disabled="exporting" @click="handle('exportFile')">
                <icon-download size="13" style="marginRight:5px;"/>
                {{ $t('stock.exportShipment') }}
            </a-button>
            <a-divider direction="vertical" v-permission="'setting.stock.exportExchange'"/>
            <a-alert class="countBar">
                <span>{{$t('stock.asOf')}}{{warningDate}} 00:00:00， {{$t('stock.bikeCount2')}}：{{unoutboundCount.bike}}，</span>
                <span>{{$t('stock.bomCount2')}}：{{unoutboundCount.bom}}</span>
            </a-alert>
        </div>

        <Table 
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
            @cellDblClick="cellDblClick"
        >
            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'order_name'">
                    <a-popover position="top"  trigger="click" @popup-visible-change="(val)=>popupVisibleChangeAmount(val,props.record)">
                        <a-button type="text" style="text-wrap: wrap;">{{ props.record.order_name }}</a-button>
                        <template #content>
                            <a-spin :loading="amountInfo_loading" tip="loading..." class="customer_info">
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.orderName') }}：</span>{{ amountInfo.order_name }}</div>
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.orderAmount') }}：</span>{{ amountInfo.order_amount }}</div>
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.payAmount') }}：</span>{{ amountInfo.pay_amount }}</div>
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.orderDiscount') }}：</span>{{ amountInfo.order_discount }}</div>
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.refundAmount') }}：</span>{{ amountInfo.refund_amount }}</div>
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.orderTax') }}：</span>{{ amountInfo.order_tax }}</div>
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.taxRate') }}：</span>{{ amountInfo.tax_rate }}</div>
                            </a-spin>
                        </template>
                    </a-popover>
                </div>

                <div v-if="props.column.key == 'status'">
                    <a-tag :color="props.record.status_val == 1? 'red' : props.record.status_val == 2? 'green' : props.record.status_val == 3? 'orange' : props.record.status_val == 4? 'blue' : 'gray' ">{{ props.record.status }}</a-tag>
                </div>
                <div v-if="props.column.key == 'model_model_year'">
                    <div v-if="props.record.model == '-' && props.record.model_year == '-'" style="font-size:12px">-</div>
                    <div v-else style="font-size:12px">{{ props.record.model }}，{{props.record.model_year}}</div>
                </div>
                <div v-if="props.column.key == 'brand_part_name'">
                    <div style="font-size:12px;color: #666;">{{ $t('stock.brandName') }}: {{ props.record.brand_name }}</div>
                    <div style="font-size:12px;color: #666;">{{ $t('stock.partName') }}: {{ props.record.part_name }}</div>
                </div>
                <div v-if="props.column.key == 'return_date'">
                    <div style="color:#4080ff">{{ $t('stock.plan') }}: {{ props.record.back_timestamp }}</div>
                    <div style="color:#4080ff">{{ $t('stock.real') }}: {{ props.record.back_real_timestamp }}</div>
                </div>
                <div v-if="props.column.key == 'outbound_date'">
                    <div style="color:#4080ff">{{ $t('stock.plan') }}: {{ props.record.swap_timestamp_plan }}</div>
                    <div style="color:#4080ff">{{ $t('stock.real') }}: {{ props.record.swap_timestamp_real }}</div>
                </div>
                <div v-if="props.column.key == 'logistics'" class="logisticsInfo">
                    <div>{{ $t('stock.logisticsType') }}：{{ props.record.courier_type }}</div>
                    <div>{{ $t('stock.logisticsNo') }}：{{ props.record.courier_no }}</div>
                    <div>{{ $t('stock.logisticsLink') }}：<span style="display：inline-block;white-space:wrap;">{{ props.record.courier_url }}</span></div>
                </div>
                <div v-if="props.column.key == 'swap_logistics'" class="logisticsInfo">
                    <div>{{ $t('stock.logisticsType') }}：{{ props.record.swap_courier_type }}</div>
                    <div>{{ $t('stock.logisticsNo') }}：{{ props.record.swap_courier_no }}</div>
                    <div>{{ $t('stock.logisticsLink') }}：<span style="display：inline-block;white-space:wrap;">{{ props.record.swap_courier_url }}</span></div>
                </div>
                <div v-if="props.column.key == 'frame_number'" class="frameNumber">
                    <div class="frameNumberDiv">
                        <div v-if="props.record.frame_number_arr.length > 0 && props.record.frameNumberIsText" class="frameNumberTextParent">
                            <div v-for="(item,index) in props.record.frame_number_arr" :key="index" class="frameNumberText" :style="{'color':item.VEHICLE_STATUS == 1?'red' : '#333'}">
                                {{ item.FRAME_NUMBER }}
                            </div>
                        </div>
                        <div v-else-if="props.record.frame_number_arr.length > 0 && !props.record.frameNumberIsText" class="frameNumberInput">
                            <div v-for="(item,index) in props.record.frame_number_arr" :key="index" >
                                <a-input :style="{width:'140px',marginTop:'5px'}" v-model="props.record.frame_number_arr[index].FRAME_NUMBER" />
                            </div>
                        </div>
                        <div v-else-if="props.record.frame_number_arr.length == 0 && !props.record.frameNumberIsText" class="frameNumberInput">
                            <a-input :style="{width:'140px',marginTop:'5px'}" v-model="props.record.frame_number_arr[0].FRAME_NUMBER" />
                        </div>
                        <div v-else-if="props.record.frame_number_arr.length == 0 && props.record.frameNumberIsText">-</div>
                    </div>
                </div>

                <div v-if="props.column.key == 'po'" class="frameNumber">
                    <div class="frameNumberDiv">
                        <div v-if="props.record.frame_number.length > 0" class="frameNumberTextParent">
                            <div v-for="(item,index) in props.record.frame_number" :key="index" class="frameNumberText">
                                <span v-if="item.BOX_NO">{{ item.BOX_NO }}</span>   
                                <span v-else>-</span>   
                            </div>
                        </div>
                        <div v-else-if="props.record.frame_number.length == 0">-</div>
                    </div>
                </div>

                <div v-if="props.column.key == 'customer_name'" >
                    <a-popover position="top"  trigger="click" @popup-visible-change="(val)=>popupVisibleChange(val,props.record)">
                        <a-button type="text" style="text-wrap: wrap;text-align: left;">{{ props.record.customer_name }}</a-button>
                        <template #content>
                            <a-spin :loading="customerInfo_loading" tip="loading..." class="customer_info" style="min-width:250px" >
                                <div class="edit_icon" v-if="!is_hepha_customer">
                                    <icon-edit :size="18" @click="editCustomer(customerInfo.name)"/>
                                </div>
                                <div style="display:inline-block;margin-right:15px;vertical-align: top;">
                                    <div><span style="font-weight:bold">{{ $t('customer.contactName3') }}：</span> {{ customerInfo.name }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.contactName2') }}：</span>{{ customerInfo.name2 }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.customerPhone') }}：</span> {{ customerInfo.phone }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.zip') }}：</span> {{ customerInfo.zip }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.customerCity') }}：</span> {{ customerInfo.city }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.customerAddr') }}：</span> {{ customerInfo.address }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.customerAddr2') }}：</span> {{ customerInfo.address2 }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.billingAddress') }}：</span> {{ customerInfo.billing_address }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.customerEmail') }}：</span> {{ customerInfo.email }}</div>
                                </div>
                            </a-spin>
                        </template>
                    </a-popover>
                </div>

                <div v-if="props.column.key == 'instruction' && userInfo.role != '8'" class="remark">
                    <a-tooltip :content="props.record.instruction">
                        <div class="remark_content" v-if="props.record.remarkIsText">{{ props.record.instruction }}</div>
                    </a-tooltip>
                    
                    <a-input v-if="!props.record.remarkIsText" :style="{width:'180px'}" v-model="props.record.instruction" />
                    <icon-check v-if="!props.record.remarkIsText" @click="saveComment(props.record)" :style="{display:'inline-block',marginLeft:'5px',color:'green',cursor:'pointer',fontWeight:'blod'}"/>
                    <icon-close v-if="!props.record.remarkIsText" @click="cancelSaveComment(props.record)" :style="{display:'inline-block',marginLeft:'10px',color:'red',cursor:'pointer',fontWeight:'blod'}"/>
                </div>
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button v-permission="'setting.stock.edit'"  type="primary" size="mini" style="margin-top:5px;width:72px" :disabled="props.record.status_val == 3" @click="handle('edit',props.record)">{{ $t('base.edit') }}</a-button>
                <a-button v-permission="'setting.stock.detail'"  type="primary" size="mini" style="margin-top:5px;width:72px" @click="handle('detail',props.record)">{{ $t('base.detail') }}</a-button>
                <a-button v-permission="'setting.stock.cancelSwap'" type="primary" status="danger" size="mini" :disabled="props.record.status_val != 1 && props.record.status_val != 4" style="margin-top:5px;width:72px" @click="handle('cancelSwap',props.record)">{{ $t('stock.cancelSwap') }}</a-button>
            </template>
        </Table>

        <a-modal 
            v-model:visible="visible" 
            :onBeforeOk="signforBeforeOk" 
            @ok="handleSignfor" 
            @cancel="handleCancel"
        >
            <template #title>{{ $t('stock.signFor') }}</template>
            <div style="text-align:center">
                {{ $t('stock.signForDate') }}：<a-date-picker v-model="sign_for_date" show-time style="width: 200px;" />
            </div>
        </a-modal>

        <a-modal 
            v-model:visible="editVisible" 
            :onBeforeOk="editBeforeOk" 
            width="800px"
            @ok="saveEditStock" 
            @cancel="handleCancel"
        >
            <template #title>{{ $t('base.edit') }}</template>
            <div style="text-align:center">
                <a-divider class="swapLogisticsInfoTitle" orientation="center">{{ $t('stock.swapLogisticsInfo') }}</a-divider>
                <Form 
                    :form="editForm"
                    @handleSelectChange="handleEditSelectChange"
                    @handleInput="handleInput"
                ></Form>
                <a-divider class="returnLogisticsInfoTitle" orientation="center">{{ $t('stock.returnLogisticsInfo') }}</a-divider>
                <Form 
                    :form="editForm2"
                    @handleSelectChange="handleEditSelectChange"
                    @handleInput="handleInput2"
                ></Form>
            </div>
        </a-modal>

        <!--  详情 -->
        <Detail :row="rowData" :detailVisible="detailVisible" :type="2" @handleCancel="handleCancelDrawer"></Detail>

    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { useRouter } from 'vue-router';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import Detail from './Detail.vue';
    import { SwapQueryForm, SwapEditForm, SwapEditForm2 } from './queryConfig/SwapQueryForm.js';
    import { dateToTimestamp, timestampToDate, getNowDate, formatterToPoint, formatterToComma, } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';

    const ENV_MODE = import.meta.env.MODE

    const { t } = useI18n()
    const router = useRouter()

    const localeStore = useLocale()

    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    const visible = ref(false)
    const editVisible = ref(false)
    const detailVisible = ref(false)
    const customerInfo_loading = ref(false)
    const amountInfo_loading = ref(false)
    const showForm = ref(false)
    const customerInfo = ref({})
    const amountInfo = ref({})
    const sign_for_date = ref('')
    const rowData = ref(null)
    const queryForm = reactive(SwapQueryForm)
    const editForm = reactive(SwapEditForm)
    const editForm2 = reactive(SwapEditForm2)
    const warningDate = ref(getNowDate().split(' ')[0])
    const warningtimestamp = ref(dateToTimestamp(`${warningDate.value} 00:00:00`))
    const timezoneOffset = ref(new Date().getTimezoneOffset() / 60)  // 获取当前时区的偏移量 ， 偏移量=-8 ==> 北京时间   偏移量=-2 ==> 柏林时间
    const timeDiff = ref(6 * 60 * 60 * 1000) // 中国与德国时差
    const unoutboundCount = reactive({
        bom:0,
        bike:0,
    })
    const exporting = ref(false)
    const is_hepha_customer = ref('')

    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'50',
                fixed:'left',
                align:'left',
            },
            {
                // title: '订单名称',
                title: t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'160',
                ellipsis:true,
                tooltip:true,  
                fixed:'left',
                align:'left',
                slotName:'slot'
            },
            {
                // title: 'mes退货单号',
                title: t('returnExchange.backNumber'),
                dataIndex: 'back_number',
                key:'back_number',
                width:'170',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: 'mes换货单号',
                title: t('stock.swapNumber'),
                dataIndex: 'swap_number',
                key:'swap_number',
                width:'170',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: 'sku',
                title: t('order.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'200',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: '换货sku',
                title: t('stock.swapSku'),
                dataIndex: 'swap_sku',
                key:'swap_sku',
                width:'200',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: '出库状态',
                title: t('stock.swapStatus'),
                dataIndex: 'status',
                key:'status',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '产品名称',
                title: t('order.productName'),
                dataIndex: 'name',
                key:'name',
                width:'200',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: '车型/上市年份',
                title:t('stock.modelModelYear'),
                dataIndex: 'model_model_year',
                key:'model_model_year',
                width:'200',
                align:'left',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            // {
            //     // title: '车型',
            //     title:t('order.model'),
            //     dataIndex: 'model',
            //     key:'model',
            //     width:'120',
            //     align:'center',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            // {
            //     // title: '上市年份',
            //     title:t('order.modelYear'),
            //     dataIndex: 'model_year',
            //     key:'model_year',
            //     width:'120',
            //     align:'center',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            {
                // title: '品牌名称',
                title:t('stock.brandPartName'),
                dataIndex: 'brand_part_name',
                key:'brand_part_name',
                width:'160',
                align:'left',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            // {
            //     // title: '品牌名称',
            //     title:t('order.brandName'),
            //     dataIndex: 'brand_name',
            //     key:'brand_name',
            //     width:'120',
            //     align:'center',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            // {
            //     // title: '零件名称',
            //     title:t('order.partName'),
            //     dataIndex: 'part_name',
            //     key:'part_name',
            //     width:'120',
            //     align:'center',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            {
                // title: '数量',
                title: t('stock.swapQty'),
                dataIndex: 'swap_quantity',
                key:'swap_quantity',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // slotName:'slot'
            },
            {
                // title: '客户',
                title: t('order.customerName'),
                dataIndex: 'customer_name',
                key:'customer_name',
                width:'230',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '退回时间',
                title: t('stock.returnDate'),
                dataIndex: 'return_date',
                key:'return_date',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            // {
            //     // title: '预计退回时间',
            //     title: t('stock.backDate'),
            //     dataIndex: 'back_timestamp',
            //     key:'back_timestamp',
            //     width:'170',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            //     slotName:'slot'
            // },
            // {
            //     // title: '实际退回时间',
            //     title: t('stock.backReceiveDate'),
            //     dataIndex: 'back_real_timestamp',
            //     key:'back_real_timestamp',
            //     width:'180',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            //     slotName:'slot'
            // },
            {
                // title: '出库时间',
                title: t('stock.outboundDate'),
                dataIndex: 'outbound_date',
                key:'outbound_date',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            // {
            //     // title: '预计发货日期',
            //     title: t('stock.swapDatePlan'),
            //     dataIndex: 'swap_timestamp_plan',
            //     key:'swap_timestamp_plan',
            //     width:'170',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            //     slotName:'slot'
            // },
            // {
            //     // title: '实际发货日期',
            //     title: t('stock.swapDateReal'),
            //     dataIndex: 'swap_timestamp_real',
            //     key:'swap_timestamp_real',
            //     width:'180',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            //     slotName:'slot'
            // },
            {
                // title: '退货物流信息',
                title: t('stock.returnLogistics'),
                dataIndex: 'logistics',
                key:'logistics',
                width:'220',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '换货物流信息',
                title: t('stock.swapLogistics'),
                dataIndex: 'swap_logistics',
                key:'swap_logistics',
                width:'220',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '运费',
                title: t('stock.cargoFreight'),
                dataIndex: 'cargo_freight',
                key:'cargo_freight',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '车架号',
                title: t('order.frameNumber'),
                dataIndex: 'frame_number',
                key:'frame_number',
                width:'250',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: 'PO号',
                title: t('stock.po'),
                dataIndex: 'po',
                key:'po',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: 'erp订单号',
                title: t('order.erpNo'),
                dataIndex: 'erp_no',
                key:'erp_no',
                width:'160',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: 'erp物料号',
                title: t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                width:'160',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '仓库',
                title: t('order.warehouse'),
                dataIndex: 'swap_inventory',
                key:'swap_inventory',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '创建人',
                title: t('order.createUser'),
                dataIndex: 'create_user',
                key:'create_user',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '备注',
                title: t('stock.remark'),
                dataIndex: 'instruction',
                key:'instruction',
                width:'270',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'110',
                align:'left',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                x:1000,
                y:680,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
            
        },
    })

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getList()
                break;
            case 'reset':
                queryForm.formField.forEach(i=>{
                    queryForm.formData[i.key] = ''
                })
                table.value.configs.pagination.current = 1
                getList()
                break;
            case 'signFor':
                visible.value = true
                rowData.value = row
                break;
            case 'edit':
                editVisible.value = true
                rowData.value = row

                editForm.formField.forEach(i=>{
                    if(i.key == 'cargo_freight'){
                        editForm.formData[i.key] = row[i.key] == '-'? '' : formatterToComma(row[i.key].split('€')[1].trim(), timezoneOffset.value == '-8')
                    }else if(i.key == 'swap_courier_status'){
                        editForm.formData[i.key] = row[i.key] != '3'? '' : row[i.key]
                    }else{
                        editForm.formData[i.key] = row[i.key] == '-'? '' : row[i.key]
                    }
                })
                editForm2.formField.forEach(i=>{
                    editForm2.formData[i.key] = row[i.key] == '-'? '' : row[i.key]
                })
                editForm.formData.swap_courier_id = ''
                editForm2.formData.courier_id = ''
                
                let swap_courier_type = editForm.formField.find(i=>i.key == 'swap_courier_type')
                let swap_courier_no = editForm.formField.find(i=>i.key == 'swap_courier_no')
                let swap_courier_url = editForm.formField.find(i=>i.key == 'swap_courier_url')
                let swap_courier_status = editForm.formField.find(i=>i.key == 'swap_courier_status')
                let return_courier_type = editForm2.formField.find(i=>i.key == 'courier_type')
                let return_courier_no = editForm2.formField.find(i=>i.key == 'courier_no')
                let return_courier_url = editForm2.formField.find(i=>i.key == 'courier_url')
                // 寄出物流信息
                let reg = /^[0-9]{8}$/g
                let swap_bool = reg.test(editForm.formData.swap_courier_no)
                swap_courier_type.disabled = rowData.value.status_val == 2 && !!editForm.formData.swap_courier_type && !!editForm.formData.swap_courier_no
                swap_courier_no.disabled = editForm.formData.swap_courier_type === 'Cargoboard' && !swap_bool? false : rowData.value.status_val == 2 && !!editForm.formData.swap_courier_type && !!editForm.formData.swap_courier_no
                swap_courier_url.disabled = rowData.value.status_val == 2 && !!editForm.formData.swap_courier_type && !!editForm.formData.swap_courier_no
                swap_courier_status.disabled = rowData.value.status_val == 1 || editForm.formData.swap_courier_type === 'Cargoboard' || editForm.formData.swap_courier_type === 'DHL'
                // 退回物流信息
                let bool = reg.test(editForm.formData.courier_no)
                return_courier_type.disabled = rowData.value.status_val == 2 && !!editForm2.formData.courier_type && !!editForm2.formData.courier_no
                return_courier_no.disabled = editForm.formData.courier_type === 'Cargoboard' && !bool? false : rowData.value.status_val == 2 && !!editForm2.formData.courier_type && !!editForm2.formData.courier_no
                return_courier_url.disabled = rowData.value.status_val == 2 && !!editForm2.formData.courier_type && !!editForm2.formData.courier_no
                break;
            case 'detail':
                detailVisible.value = true
                rowData.value = row
                break;
            case 'cancelSwap':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.cancelSwapConfirmTip') + `【${row.order_name}】?`,
                    hideCancel:false,
                    width:500,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        cancelSwap(row)
                    }
                });
                break;
            case 'exportFile':
                exportFile()
                break;
        }
    }

    const handleCancelDrawer = ()=>{
        detailVisible.value = false
    }

    const editCustomer = (name)=>{
        router.push({path:'/Customers/CustomerList', query:{customer_name:name,fromPage:'Outbounds/StockOutList'}})
    }

    const handleSelectChange = (val,item,key)=>{
        // console.log(val,item,key,'keyyyyy')
        table.value.configs.pagination.current = 1
        getList()
    }

    // 列表查询-input
    const handleInputClear = (item, val)=>{
        table.value.configs.pagination.current = 1
        getList()
    }

    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getList()
    }

    const handleEditSelectChange = (val,item,key)=>{
        console.log(val,item,key, 'val,item,key')

        let courierTypeArr = ['Cargoboard','DHL','ZUFALL','Factory','SIMPLELOGISTIK','Raben']
        let swap_courier_no_item = editForm.formField.find(i=> i.key == 'swap_courier_no')
        if(key == 'swap_courier_type'){
            swap_courier_no_item.required = courierTypeArr.includes(val)
            editForm.formData.swap_courier_no = editForm.formData.swap_courier_type == 'Factory'? '000000' : ''
        }

        let courier_no_item = editForm2.formField.find(i=> i.key == 'courier_no')
        if(key == 'courier_type'){
            courier_no_item.required = courierTypeArr.includes(val)
            editForm2.formData.courier_no = editForm2.formData.courier_type == 'Factory'? '000000' : ''
        } 
    }

    const handleInput = (item,val)=>{
        if(item.key == 'swap_courier_no'){
            let swap_courier_no_item = editForm.formField.find(i=> i.key == 'swap_courier_no')
            if(editForm.formData.swap_courier_type === 'Cargoboard'){
                swap_courier_no_item.maxLength = 8
                editForm.formData[item.key] = val.replace(/[^0-9]/g,'')
            }else{
                swap_courier_no_item.maxLength = ''
                editForm.formData[item.key] = val.replace(/[^a-zA-Z0-9]/g,'')
            }
        }

        if(item.key == 'cargo_freight'){
            editForm.formData.cargo_freight = val.replace(/-/g, '')
        }
    }

    const handleInput2 = (item,val)=>{
        if(item.key == 'courier_no'){
            let courier_no_item = editForm2.formField.find(i=> i.key == 'courier_no')
            if(editForm2.formData.courier_type === 'Cargoboard'){
                courier_no_item.maxLength = 8
                editForm2.formData[item.key] = val.replace(/[^0-9]/g,'')
            }else{
                courier_no_item.maxLength = ''
                editForm2.formData[item.key] = val.replace(/[^a-zA-Z0-9]/g,'')
            }
        }
    }

    const handlePickerDateChange = (val,item)=>{
        console.log(val,item,'iiiiii')
        table.value.configs.pagination.current = 1
        if(item.key == 'back_timestamp'){
            queryForm.formData.back_begin_plan_date = !val? '' : dateToTimestamp(val[0])
            queryForm.formData.back_end_plan_date = !val? '' : dateToTimestamp(val[1])
        }
        if(item.key == 'back_real_timestamp'){
            queryForm.formData.back_begin_real_date = !val? '' : dateToTimestamp(val[0])
            queryForm.formData.back_end_real_date = !val? '' : dateToTimestamp(val[1])
        }
        if(item.key == 'swap_timestamp_plan'){
            queryForm.formData.out_begin_plan_date = !val? '' : dateToTimestamp(val[0])
            queryForm.formData.out_end_plan_date = !val? '' : dateToTimestamp(val[1])
        }
        if(item.key == 'swap_timestamp_real'){
            queryForm.formData.out_begin_real_date = !val? '' : dateToTimestamp(val[0])
            queryForm.formData.out_end_real_date = !val? '' : dateToTimestamp(val[1])
        }
        
        getList()
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getList()
    }

    const popupVisibleChange = (val,row)=>{
        if(val) getCustomer(row.customer_id)
    }  

    const popupVisibleChangeAmount = (val,row)=>{
        if(val) getAmount(row.order_id)
    }

    // 双击单元格
    const cellDblClick = (row,column)=>{
        // console.log(column,'col')
        if(column.key == 'instruction'){
            row.remarkIsText = false
        }
        // if(column.key == 'frame_number'){
        //     row.frameNumberIsText = false
        // }
        
    }

    const cancelSaveComment = (row)=>{
        row.remarkIsText = true
        getList()
    }

    // 导出换货单
    const exportFile = async ()=>{
        let form = {}
        queryForm.formField.forEach(i=>{
            if(i.key !== 'back_timestamp' && i.key !== 'back_real_timestamp' & i.key !== 'swap_timestamp_plan' && i.key !== 'swap_timestamp_real' && i.key !== 'customer_id'){
                form[i.key] = queryForm.formData[i.key]
            }
        })
        let param = {
            ...form,
            type:2,
            order_name:queryForm.formData.order_name.trim(),
            swap_number: queryForm.formData.swap_number.toUpperCase().trim(),
            erp_no:queryForm.formData.erp_no.trim(),
            customer_entity_id:queryForm.formData.customer_id,
            back_begin_plan_date: !queryForm.formData.back_timestamp? '' : dateToTimestamp(`${queryForm.formData.back_timestamp[0]} 00:00:00`),
            back_end_plan_date: !queryForm.formData.back_timestamp? '' : dateToTimestamp(`${queryForm.formData.back_timestamp[1]} 23:59:59`),
            back_begin_real_date: !queryForm.formData.back_real_timestamp? '' : dateToTimestamp(`${queryForm.formData.back_real_timestamp[0]} 00:00:00`),
            back_end_real_date: !queryForm.formData.back_real_timestamp? '' : dateToTimestamp(`${queryForm.formData.back_real_timestamp[1]} 23:59:59`),
            out_begin_plan_date: !queryForm.formData.swap_timestamp_plan? '' : dateToTimestamp(`${queryForm.formData.swap_timestamp_plan[0]} 00:00:00`),
            out_end_plan_date: !queryForm.formData.swap_timestamp_plan? '' : dateToTimestamp(`${queryForm.formData.swap_timestamp_plan[1]} 23:59:59`),
            out_begin_real_date: !queryForm.formData.swap_timestamp_real? '' : dateToTimestamp(`${queryForm.formData.swap_timestamp_real[0]} 00:00:00`),
            out_end_real_date: !queryForm.formData.swap_timestamp_real? '' : dateToTimestamp(`${queryForm.formData.swap_timestamp_real[1]} 23:59:59`),
        }
        Message.success(t('base.exporting'))
        exporting.value = true
        let res = await StockOutApi.getInstance().exportExchange(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${t('stock.exportExchangeData')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            exporting.value = false
            Message.success(t('base.exportSuccess'))
        }else{
            Message.error(res.msg)
        }
    }

    // 保存车架号
    const saveFrameNumber = (row)=>{
        // console.log(row.frame_number_arr.join(','),row,'rrrrr')

        for(let i=0;i<row.frame_number_arr.length;i++){
            let item = row.frame_number_arr[i]
            if(item.FRAME_NUMBER === ''){
                Message.error(t('stock.frameNumber')+' '+t('base.noEmpty'))
                return
            }
        }

        Modal.warning({
            title: t('base.tip'),
            titleAlign:'start',
            hideCancel:false,
            content: t('stock.confirmFrameNumber'),
            okText:t('base.ok'),
            cancelText:t('base.cancel'),
            onOk:async ()=>{
                let param = {
                    frame_number:row.frame_number_arr.join(',')
                }
                let res = await StockOutApi.getInstance().editFrameNumber(param,row.id)
                if(res.code == 0){
                    Message.success(t('base.saveSuccess'))
                    getList()
                }else{
                    Message.error(res.msg)
                }
            }
        });
    }

    //  取消保存车架
    const cancelSaveFrameNumber = (row)=>{
        row.frameNumberIsText = true
        getList()
    }

    // 获取列表
    const getList = async ()=>{
        let form = {}
        queryForm.formField.forEach(i=>{
            if(i.key !== 'back_timestamp' && i.key !== 'back_real_timestamp' & i.key !== 'swap_timestamp_plan' && i.key !== 'swap_timestamp_real' && i.key !== 'customer_id'){
                form[i.key] = queryForm.formData[i.key]
            }
        })
        let param = {
            ...form,
            type:2,
            order_name:queryForm.formData.order_name.trim(),
            swap_number: queryForm.formData.swap_number.toUpperCase().trim(),
            erp_no:queryForm.formData.erp_no.trim(),
            customer_entity_id:queryForm.formData.customer_id,
            back_begin_plan_date: !queryForm.formData.back_timestamp? '' : dateToTimestamp(`${queryForm.formData.back_timestamp[0]} 00:00:00`),
            back_end_plan_date: !queryForm.formData.back_timestamp? '' : dateToTimestamp(`${queryForm.formData.back_timestamp[1]} 23:59:59`),
            back_begin_real_date: !queryForm.formData.back_real_timestamp? '' : dateToTimestamp(`${queryForm.formData.back_real_timestamp[0]} 00:00:00`),
            back_end_real_date: !queryForm.formData.back_real_timestamp? '' : dateToTimestamp(`${queryForm.formData.back_real_timestamp[1]} 23:59:59`),
            out_begin_plan_date: !queryForm.formData.swap_timestamp_plan? '' : dateToTimestamp(`${queryForm.formData.swap_timestamp_plan[0]} 00:00:00`),
            out_end_plan_date: !queryForm.formData.swap_timestamp_plan? '' : dateToTimestamp(`${queryForm.formData.swap_timestamp_plan[1]} 23:59:59`),
            out_begin_real_date: !queryForm.formData.swap_timestamp_real? '' : dateToTimestamp(`${queryForm.formData.swap_timestamp_real[0]} 00:00:00`),
            out_end_real_date: !queryForm.formData.swap_timestamp_real? '' : dateToTimestamp(`${queryForm.formData.swap_timestamp_real[1]} 23:59:59`),
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await StockOutApi.getInstance().getOutList(param, page_num, page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                table.value.datas.push({
                    ...item,
                    No: index + 1,
                    status_val: item.status,
                    status: !item.status? '-' : item.status == 1? t('order.swaping') : item.status == 2? t('order.exchangeSuccessful') : item.status == 3? t('stock.cancelSwap2') : item.status == 4? t('stock.outScanned') : t('order.initial'),
                    erp_no: !item.erp_no? '-' : item.erp_no,
                    sku: !item.sku? '-' : item.sku,
                    swap_sku: !item.swap_sku? '-' : item.swap_sku,
                    name:!item.swap_product_map? '-' : item.swap_product_map.english_name,
                    back_number: !item.back_number? '-' : item.back_number,
                    swap_number: !item.swap_number? '-' : item.swap_number,
                    cargo_freight: !item.cargo_freight? '-' : `€  ${formatterToComma(Number(item.cargo_freight),timezoneOffset.value == '-8')}`,
                    frame_number: !item.frame_number? '-' : item.frame_number,
                    // frame_number_arr: !item.frame_number? [] : item.frame_number.map(i=>{return i.FRAME_NUMBER}),
                    frame_number_arr: !item.frame_number? [] : item.frame_number,
                    inventory_code: !item.inventory_code? '-' : item.inventory_code,
                    courier_type:!item.back_courier_map? '-' : !item.back_courier_map.courier_type? '-' : item.back_courier_map.courier_type,
                    courier_no:!item.back_courier_map? '-' : !item.back_courier_map.courier_no? '-' : item.back_courier_map.courier_no,
                    courier_url:!item.back_courier_map? '-' : !item.back_courier_map.courier_url? '-' : item.back_courier_map.courier_url,
                    swap_courier_type:!item.swap_courier_map? '-' : !item.swap_courier_map.courier_type? '-' : item.swap_courier_map.courier_type,
                    swap_courier_no:!item.swap_courier_map? '-' : !item.swap_courier_map.courier_no? '-' : item.swap_courier_map.courier_no,
                    swap_courier_url:!item.swap_courier_map? '-' : !item.swap_courier_map.courier_url? '-' : item.swap_courier_map.courier_url,
                    swap_courier_status:!item.swap_courier_map? '-' : !item.swap_courier_map.courier_status? '-' : item.swap_courier_map.courier_status,
                    back_timestamp: !item.back_timestamp? '-' : timestampToDate(item.back_timestamp * 1000).split(' ')[0],
                    back_real_timestamp: !item.back_real_timestamp? '-' : timestampToDate(item.back_real_timestamp * 1000).split(' ')[0],
                    swap_timestamp_plan: !item.swap_timestamp_plan? '-' : timestampToDate(item.swap_timestamp_plan * 1000).split(' ')[0],
                    swap_timestamp_real: !item.swap_timestamp_real? '-' : timestampToDate(item.swap_timestamp_real * 1000).split(' ')[0],
                    sign_time: !item.sign_time? '-' : timestampToDate(item.sign_time * 1000).split(' ')[0],
                    swap_inventory: !item.swap_inventory? '-' : item.swap_inventory,
                    remarkIsText:true,
                    frameNumberIsText:true,
                    instruction: !item.instruction? '' : item.instruction,
                    create_user: !item.create_user? '-' : item.create_user,
                    model: item.swap_product_map == undefined ? '-' : item.swap_product_map.model == undefined? '-' : item.swap_product_map.model,
                    model_year: item.swap_product_map == undefined ? '-' : item.swap_product_map.model_year == undefined? '-' : item.swap_product_map.model_year,
                    brand_name: item.swap_product_map == undefined ? '-' : item.swap_product_map.brand_name == undefined? '-' :  item.swap_product_map.brand_name,
                    part_name: item.swap_product_map == undefined ? '-' : item.swap_product_map.part_name == undefined? '-' :  item.swap_product_map.part_name,
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.pagination.current = res.data.current
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 签收校验
    const signforBeforeOk = ()=>{
        console.log(sign_for_date.value,'sign_for_date.value')
        if(!sign_for_date.value){
            Message.error(t('stock.signTime')+' '+t('base.noEmpty'))
            return false
        }

        return true
    }

    // 签收
    const handleSignfor = async()=>{
        let param = {
            order_line_ids: rowData.value.order_line_id,
            sign_time: dateToTimestamp(sign_for_date.value),
        }
        console.log(param,'ppp')
        let res = await StockOutApi.getInstance().signFor(param,rowData.value.id)
        if(res.code == 0){
            Message.success(t('stock.signForSuccess'))
            getList()
        }else{
            Message.error(res.msg)
        }
    }

    // 编辑校验
    const editBeforeOk = ()=>{
        let formData = editForm.formData
        let formData2 = editForm2.formData
        if(!formData.swap_courier_type && !formData.swap_courier_no && !formData.swap_courier_url && !formData.cargo_freight){
            Message.error(t('stock.contentTip'))
            return false
        }else if(!!formData.swap_courier_type && (formData.swap_courier_type == 'Cargoboard' || formData.swap_courier_type == 'DHL') && !formData.swap_courier_no){
            Message.error(t('stock.swapCourierNo') + ' ' + t('base.noEmpty'))
            return false
        }else if(!!formData.swap_courier_type && formData.swap_courier_type != 'Cargoboard' && formData.swap_courier_type != 'DHL' && !formData.swap_courier_no && !formData.swap_courier_url){
            Message.error(t('stock.contentTip2'))
            return false
        }else if(!!formData2.courier_type && (formData2.courier_type == 'Cargoboard' || formData2.courier_type == 'DHL') && !formData2.courier_no){
            Message.error(t('stock.returnCourierNo') + ' ' + t('base.noEmpty'))
            return false
        }else if(!!formData2.courier_type && formData2.courier_type != 'Cargoboard' && formData2.courier_type != 'DHL' && !formData2.courier_no && !formData2.courier_url){
            Message.error(t('stock.contentTip3'))
            return false
        }

        return true
    }

    // 编辑出库信息
    const saveEditStock = async()=>{
        // 寄出物流
        if(
            (!!editForm.formData.swap_courier_type && !!editForm.formData.swap_courier_no) || 
            (!!editForm.formData.swap_courier_type && !!editForm.formData.swap_courier_url && editForm.formData.swap_courier_type !== 'Cargoboard' && editForm.formData.swap_courier_type !== 'DHL')
        ){
            await getCourierId()
        }

        // 退回物流
        if(
            (!!editForm2.formData.courier_type && !!editForm2.formData.courier_no) || 
            (!!editForm2.formData.courier_type && !!editForm2.formData.courier_url && editForm2.formData.courier_type !== 'Cargoboard' && editForm2.formData.courier_type !== 'DHL')
        ){
            await getReturnCourierId()
        }

        let form = {}, param = {}
        editForm.formField.forEach(i=>{
            if(i.key == 'cargo_freight'){
                form[i.key] = editForm.formData[i.key] == undefined? '' : formatterToPoint(editForm.formData[i.key])
            }else{
                form[i.key] = !editForm.formData[i.key]? '' : editForm.formData[i.key]
            }
        })
        editForm2.formField.forEach(i=>{
            form[i.key] = !editForm2.formData[i.key]? '' : editForm2.formData[i.key]
        })
        if(editForm.formData.swap_courier_id) form.swap_courier_id = editForm.formData.swap_courier_id
        if(editForm2.formData.courier_id) form.courier_id = editForm2.formData.courier_id

        param = {
            out_courier_id: form.swap_courier_id,
            out_courier_type: form.swap_courier_type,
            out_courier_no: form.swap_courier_no,
            out_courier_status: form.swap_courier_status,
            cargo_freight: form.cargo_freight,
            back_courier_id: form.courier_id,
            back_courier_type: form.courier_type,
            back_courier_no: form.courier_no,
        } 
        console.log(param,'ppp')
        let res = await StockOutApi.getInstance().editBackCurrier(param,rowData.value.id)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            getList()
        }else{
            Message.error(res.msg)
        }
    }

    // 保存备注
    const saveComment = async (row)=>{
        let param = {
            instruction:row.instruction,
        }
        let res = await StockOutApi.getInstance().saveReturnComment(row.id,param)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            row.remarkIsText = true
            getList()
        }else{
            Message.error(res.msg)
        }
    }

    // 取消换货单
    const cancelSwap = async (row)=>{
        // console.log(row.id,'rowid')
        table.value.configs.loading = true
        let res = await StockOutApi.getInstance().cancelSwap(row.id)
        if(res.code == 0){
            Message.success(t('base.cancelSuccess'))
            table.value.configs.loading = false
            getList()
        }else{
            Message.error(res.msg)
        }
    }

    // 获取订单金额
    const getAmount = async (order_id)=>{
        amountInfo_loading.value = true
        let res = await StockOutApi.getInstance().getAmount(order_id)
        if(res.code == 0){
            amountInfo.value = {
                order_name: res.data.order_name,
                order_amount: res.data.order_amount == undefined || res.data.order_amount === ''? '-' : '€ ' + Number(res.data.order_amount).toFixed(2),
                pay_amount: res.data.pay_amount == undefined || res.data.order_amount === ''? '-' : '€ ' + Number(res.data.pay_amount).toFixed(2),
                order_discount: res.data.order_discount == undefined || res.data.order_amount === ''? '-' : '€ ' + Number(res.data.order_discount).toFixed(2),
                refund_amount: res.data.refund_amount == undefined || res.data.order_amount === ''? '-' : '€ ' + Number(res.data.refund_amount).toFixed(2),
                order_tax: res.data.order_tax == undefined || res.data.order_amount === ''? '-' : '€ ' + Number(res.data.order_tax).toFixed(2),
                tax_rate: res.data.tax_rate == undefined || res.data.order_amount === ''? '-' : res.data.tax_rate * 100 + '%',
            }
            amountInfo_loading.value = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取用户信息 
    const getCustomer = async (customer_id)=>{
        customerInfo_loading.value = true
        let res = await StockOutApi.getInstance().getCustomer(customer_id)
        if(res.code == 0){
            customerInfo.value = {
                ...res.data,
                sex:res.sex == 0? t('customer.male') : t('customer.female'),
                countryCity: !res.data.city? `${res.data.country} / -` : `${res.data.country} / ${res.data.city}`
            }
            customerInfo_loading.value = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取仓库
    const getWarehouse = async ()=>{
        let res = await StockOutApi.getInstance().getWarehouse()
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'swap_inventory')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.description,
                    value: i.subinventory_name,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取物流公司
    const getCourierType = async ()=>{
        let res = await StockOutApi.getInstance().getCourierType({dict_code: "courier"})
        if(res.code == 0){
            let item = editForm.formField.find(i=> i.key == 'swap_courier_type')
            let item2 = editForm2.formField.find(i=> i.key == 'courier_type')
            item.options = []
            item2.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value,
                })
                item2.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取寄出物流id
    const getCourierId = async ()=>{
        let param = {
            courier_type: editForm.formData.swap_courier_type,
            courier_no: editForm.formData.swap_courier_no,
            courier_url: editForm.formData.swap_courier_url,
            courier_status: editForm.formData.swap_courier_status,
        }

        if( (
                (editForm.formData.swap_courier_type == rowData.value.swap_courier_type && editForm.formData.swap_courier_no == rowData.value.swap_courier_no) ||
                (editForm.formData.swap_courier_type == rowData.value.swap_courier_type && editForm.formData.swap_courier_url == rowData.value.swap_courier_url && !editForm.formData.swap_courier_no) 
            ) && rowData.value.swap_courier_id
        ){
            param.id = rowData.value.swap_courier_id
        } 

        let res = await StockOutApi.getInstance().getCourierId(param)
        if(res.code == 0){
            editForm.formData.swap_courier_id = res.data.id
        }else{
            Message.error(res.msg)
        }
    }

    // 获取退回物流id
    const getReturnCourierId = async ()=>{
        let param = {
            courier_type: editForm2.formData.courier_type,
            courier_no: editForm2.formData.courier_no,
            courier_url: editForm2.formData.courier_url,
        }

        if( (
                (editForm2.formData.courier_type == rowData.value.courier_type && editForm2.formData.courier_no == rowData.value.courier_no) ||
                (editForm2.formData.courier_type == rowData.value.courier_type && editForm2.formData.courier_url == rowData.value.courier_url && !editForm2.formData.courier_no) 
            ) && rowData.value.back_courier_id
        ){
            param.id = rowData.value.back_courier_id
        } 
        
        let res = await StockOutApi.getInstance().getCourierId(param)
        if(res.code == 0){
            editForm2.formData.courier_id = res.data.id
        }else{
            Message.error(res.msg)
        }
    }

    // 获取产品列表,拿到SKU下拉数据
    const getProductList = async ()=>{
        let res = await StockOutApi.getInstance().getProductList({simple_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=>i.key == 'sku')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.sku,
                    value:i.sku
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取客户名称
    const getCustomerList = async ()=>{
        let res = await StockOutApi.getInstance().getCustomerList({simple_flag:1})
        if(res.code == 0){
            const item = queryForm.formField.find(i=> i.key == 'customer_id')
            item.options= []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    // label: i.name_show,
                    label: i.name,
                    value: i.id, 
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取创建人
    const getUser = async()=>{
        let res = await StockOutApi.getInstance().getUser()
        if(res.code == 0){
            const item = queryForm.formField.find(i=> i.key == 'create_by')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.user_name,
                    value: i.id,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取未换货的整车和bom数量
    const getBackUnoutboundBikeBomCount = async()=>{
        let param = {
            timestamp: warningtimestamp.value,
            type:2,
        }
        let res = await StockOutApi.getInstance().getBackUnoutboundBikeBomCount(param)
        if(res.code == 0){
            unoutboundCount.bike = res.data.bike || 0
            unoutboundCount.bom = res.data.bom || 0
        }else{
            Message.error(res.msg)
        }
    }

    // 获取bom类别
    // const getBomCategory = async ()=>{
    //     let res = await StockOutApi.getInstance().getBomCategory()
    //     if(res.code == 0){
    //         let item = queryForm.formField.find(i=> i.key == 'category_code')
    //         item.options = []
    //         res.data.forEach(i=>{
    //             if(i.CATEGORY_CODE !== undefined && i.CATEGORY_CODE !== '627.501' && i.CATEGORY_CODE !== '627.502'){
    //                 item.options.push({
    //                     label: `${i.CATEGORY_CODE} | ${i.CATEGORY_NAME}`,
    //                     value: i.CATEGORY_CODE
    //                 })
    //             }
    //         })
    //     }else{
    //         Message.error(res.msg)
    //     }
    // }

    const getBomCategory = async ()=>{
        let param = {
            dict_code:'system',
            dict_sub_code:'product_category'
        }
        let res = await StockOutApi.getInstance().getCategory(param)
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'category_code')
            item.options = []
            res.data.forEach(i=>{
                item.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value
                })
            })
        }else{
            Message.error(res.msg)
        }
    }


    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 45
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 130
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    watch(()=>editForm.formData.swap_courier_type,(val)=>{
            // console.log(val,'vvbb')
            let item = editForm.formField.find(i=> i.key == 'swap_courier_status')
            item.disabled = rowData.value.status_val == 1 || (rowData.value.status_val == 2 && (val == 'Cargoboard' || val == 'DHL'))
            if(val == 'Cargoboard' || val == 'DHL'){
                editForm.formData.swap_courier_status = ''
            }
        },
        { deep:true }
    )

    onMounted(()=>{
        getList()
        getWarehouse()
        getCourierType()
        getProductList()
        getCustomerList()
        getUser()
        getBackUnoutboundBikeBomCount()
        getBomCategory()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })

        is_hepha_customer.value = userInfo.role == 16

    })



</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:10;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }

        /deep/ .arco-form-item-layout-inline{
            margin-right: 0px;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_form2{
        flex:8;
    }
    .queryPanel_btn{
        display: flex;
        // flex-direction: column;
        // flex-wrap:wrap;
        flex: 1;
        align-items: center;
        justify-content: center;
        border-left:1px solid #eee;
        padding-left:10px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    .queryPanel_btn2{
        flex: 1;
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:90px;
    }
}

.unoutboundCount{
    margin-bottom: 7px;
    padding: 5px 24px 5px;
    background: #fff;
    font-size: 12px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-picker-size-medium{
    height: 28px;
    margin-top: 2px;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 3px 0;
    font-size:13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}


/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

.logisticsInfo{
    font-size: 12px;
    color: #666;
    // text-align: left;
}

.swapLogisticsInfoTitle{
    margin: 20px 0 30px;
}

.returnLogisticsInfoTitle{
    margin: 50px 0 30px;
}

/deep/ .arco-divider-text{
    font-weight:600;
}

.customer_info{
    font-size:12px;
    color: #666;
    padding: 0 10px;
    line-height: 18px;
}

/deep/ .arco-tabs-nav-type-line .arco-tabs-tab{
    padding:3px 0;
}

/deep/ .arco-tabs-content{
    padding-top: 7px;
}

.remark_content{
    display:inline-block;
    width:180px;
    line-height:16px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    cursor: pointer;
    
}

.remark{
    padding: 3px;
    background: #f5f5f5;
    cursor: pointer;
}

.frameNumber{
    display: flex;
    padding: 3px;
    cursor: pointer;

    .frameNumberDiv{
        display: flex;
        flex: 1;
        .frameNumberTextParent{
            display: inline-block;

            .frameNumberText{
                margin-top: 3px;
                width: 140px;
                font-size: 12px;
                // background: #f5f5f5;
            }
        }
        .frameNumberInput{
            display: inline-block;
        }
    }

    .iconBtn{
        display: flex;
        flex: 1;
        align-items: center;
        .icon{
            display:block;
            margin-left:10px;
            margin:8px;
            cursor:pointer;
            font-weight:blod;
        }
    }   
}

.edit_icon{
    float:right;
    color: #4080ff;
    cursor:pointer;
}

.unoutboundCount{
    color: #165dff;
    font-weight: 600;

    .countBar{
        display: inline-block;
        width: fit-content;
        font-size:12px;
        font-weight: 600;
    }

    /deep/ .arco-alert{
        padding: 1px 15px;
        vertical-align: bottom;

        .arco-alert-icon,
        .arco-alert-body{
            display: inline-block;
        }
    }
}

/deep/ .arco-popover-popup-content{
    padding: 8px 16px;
}
</style>